import React, { useRef, useState } from 'react'
import { css } from 'emotion'
import { Popover, Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { AdminWorkspaceIcon, PencilIcon } from 'assets/icons'
import { adminUrl } from 'config/constants/urls'
import ListMenuButton from 'src/components/PageActions/ListMenuButton'
import { useOrganization } from 'src/graphql/hooks'

const PageActions = ({ editMenuOptions }) => {
   const editPopoverButton = useRef()
   const [editPopoverIsOpen, setEditPopoverIsOpen] = useState(false)
   const { organization } = useOrganization()

   return (
      <View
         display="none[a-b] block[c-f]"
         position="fixed"
         bottom="20px"
         right="20px">
         <View
            height="40px"
            backgroundColor="rgba(40,40,40,0.97)"
            borderRadius="5px">
            <View
               ref={editPopoverButton}
               onClick={() => setEditPopoverIsOpen(true)}
               position="relative"
               float="left"
               display="flex"
               alignItems="center"
               height="40px"
               borderRadius="5px"
               padding="0px 20px"
               className={css`
                  cursor: pointer;

                  &:hover {
                     background-color: #444;
                  }
               `}>
               <View
                  display="flex"
                  alignItems="center"
                  marginRight="10px">
                  <PencilIcon
                     width="14px"
                     height="14px"
                     color="#ddd"
                  />
               </View>
               <Text size="1.5" color="#fff">Edit</Text>
            </View>
         </View>
         <Popover
            anchorElement={editPopoverButton.current}
            anchorOriginHorizontal="right"
            anchorOriginVertical="bottom"
            backgroundColor="rgba(40,40,40,0)"
            width="270px"
            onBodyClick={() => setEditPopoverIsOpen(false)}
            open={editPopoverIsOpen}>
            <View
               backgroundColor="rgba(40,40,40,0.97)"
               borderRadius="8px"
               marginBottom="6px"
               style={{ overflow: 'hidden' }}>
               <Link to={adminUrl}>
                  <ListMenuButton
                     name="Admin Workspace"
                     description="Edit your site settings"
                     icon={(
                        <AdminWorkspaceIcon
                           width="16px"
                           height="16px"
                           color="#aaa"
                        />
                     )}
                  />
               </Link>
               {organization.slug !== 'fuse' && organization.slug !== 'gns3' && editMenuOptions}
            </View>
         </Popover>
      </View>
   )
}

PageActions.propTypes = {
   editMenuOptions: PropTypes.node
}

PageActions.defaultProps = {
   editMenuOptions: undefined
}

export default PageActions
